<template>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="p-mt-6 p-mb-5 text-title">
      Confirmation de demande de devis
    </div>
    <div class="p-d-inline-flex p-jc-center p-my-6 card-container">
      <Card class="card-response">
        <template #content>
          <div class="card-response-grid" v-if="!appointmentStore.appointment.failedQuery">
            <div class="p-col-12 card-response-title">
              Merci pour votre demande de devis !
            </div>
            <div class="p-col-12 card-response-text">
              <p>
                Nous allons vous contacter dans les plus brefs délais pour
                établir un devis et vous proposer la prise en charge de votre
                véhicule dans les meilleures conditions.
              </p>
              <p>En attendant, découvrez nos actualités !</p>
              <Button class="button-navigate" @click="navigateToNews">Nos actualités</Button>
            </div>
          </div>
          <div class="card-response-grid" v-else>
            <div class="p-col-12 card-response-title">
              Il semblerait qu'un problème soit survenu.
            </div>
            <div class="p-col-12 card-response-text">
              <p>
                Excusez-nous, il semblerait qu'un problème technique ai empêché la demande de devis.
              </p>
              <p>En attendant, découvrez nos actualités !</p>
              <Button class="button-navigate" @click="navigateToNews">Nos actualités</Button>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import { useAppointmentStore } from '@/stores/appointment'
import { onBeforeRouteLeave } from 'vue-router'

export default {
  name: "StepQuoteConfirm",

  setup() {
    const appointmentStore = useAppointmentStore()

    onBeforeRouteLeave((to) => {
      if (to.fullPath === '/verifier-mes-informations') {
        location.reload()
      }
    });

    const navigateToNews = () => {
      location.replace('https://www.123parebrise.fr/notre-actualite/')
    }
    return {
      appointmentStore,
      navigateToNews
    };
  },
};
</script>

<style>
.card-container {
  width: 60%;
}
.card-response {
  width: 100% !important;
  box-shadow: none !important;
  border-radius: 10px !important;
}
.card-response .p-card-body {
  padding: 0px !important;
  border-radius: 10px !important;
}
.card-response .card-response-grid {
  border: 1px solid #24a285;
  box-shadow: none !important;
  border-radius: 10px !important;
}
.card-response .p-card-content {
  padding: 0px !important;
  text-align: center !important;
}
.card-response .p-card-content p {
  color: black !important;
  padding-top: 20px !important;
  font-size: 1.1em !important;
  line-height: 1.3em !important;
}
.card-response .card-response-title {
  background-color: #24a285 !important;
  color: white !important;
  font-size: 1.3em !important;
  line-height: 1.2em !important;
  border-radius: 8px 8px 0 0 !important;
  padding-top: 25px;
  padding-bottom: 25px;
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .card-response .card-response-title {
    border-radius: 8px 8px 0px 0px !important;
    padding-top: 10px !important;
  }
  .card-response .p-card-content p {
    line-height: 1.05em !important;
  }
  .card-container {
    width: 100%;
  }
}
</style>
